module.exports = __webpack_public_path__ + "img/73.d3236abd.jpg";